import styled from "styled-components";

// The bootstrap page intentionally shares the login page's card layout.
export { Wrapper, Card, Brand } from "../login-view/styled";

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
